import React from "react";

import { Headline } from "../../../components/Headline";
import { StructuredTextRenderer } from "../../../components/StructuredTextRenderer";
import { BlurbElement } from "../MediaBlurbElement/BlurbElement";
import { Tagline } from "../../../components/Tagline/Tagline";

import * as styles from "./mediaBlurbItem.module.less";
import { ImageWithGrid } from "../../../components/Image";
import {
    useIsMobile,
    useIsTablet,
    useIsTiny
} from "../../../lib/hooks/mediaQueries";

function MediaBlurbItem({ item }) {
    const isTiny = useIsTiny();
    const isMobile = useIsMobile();
    const isTablet = useIsTablet();

    return (
        <>
            {item.type === "DatoCmsBlurbElement" && (
                <BlurbElement
                    image={item.media}
                    heading={item.headline}
                    subheadline={item.subheadline}
                />
            )}

            {item.type === "DatoCmsNestedMediaElement" && (
                <ImageWithGrid
                    image={item.media}
                    gridSize={(isTablet && !isMobile) || isTiny ? "s" : "m"}
                    gridDisable={item.hideGrid}
                />
            )}

            {item.type === "DatoCmsNestedText" && (
                <div className={styles.nestedTextContainer}>
                    <Tagline>{item.tagline}</Tagline>

                    <Headline semanticOfHeadline={item.semanticOfHeadline}>
                        {item.headline}
                    </Headline>

                    <StructuredTextRenderer
                        data={item.text}
                        contentElementType={"MediaBlurbItem"}
                    />
                </div>
            )}
        </>
    );
}

export { MediaBlurbItem };
